export interface SchemaService {
	getSchema(): Promise<any>;
	getUiSchema(): Promise<any>;
}

export class EmptySchemaService implements SchemaService {
	getSchema = async () => undefined;
	getUiSchema = async () => undefined;
}
